/**
 * Downcase all object keys
 * @param  {Object} [obj={}]
 * @return {Object}
 */
const downcaseKeys = (obj = {}) => Object.assign(
    {},
    ...Object.keys(obj).map(
        (key) => ({ [key.toLowerCase()]: obj[key] })
    )
);
export default downcaseKeys;
